module.exports = __webpack_public_path__ + "img/open-book.191c16b8.svg";